// ====================================================================
// ziven-core forum SignUp - v0.5.2 (Trello 卡 6a7fc343f990e73904af2c75)
// ====================================================================
//
// 覆盖 vendor SignUpModal 加手机号注册 tab 切换 (辉哥 09:38 拍板 B, 5 拍板全
// 照 Coder 推荐). 实现方式: extend vendor SignUpModal.prototype (辉哥 2A 模式,
// 跟 v0.5.0/0.5.1 同款), 不是 override. 维护成本低, vendor 升级兼容好.
//
// 跟 v0.5.0 PhoneLogin.js 模式 100% 一致:
//   - vendor SignUpModal 走 lazy chunk load, 'flarum.reg.get()' 在未 load 时
//     返回 undefined. 直接 extend 会 crash 'Cannot read properties of
//     undefined (reading prototype)'.
//   - 修法: 走 flarum.reg.onLoad 等 module 加载完再 extend (SOP 250).
//
// 设计 (5 拍板):
//   - 5 拍板 1B (UI B1): extend vendor SignUpModal 加 2 主 tab (邮箱注册 / 手机号注册),
//     手机号 tab 内部子 tab (验证码 / 密码). 跟 v0.5.0/v0.5.1 PhoneLogin 同款.
//   - 5 拍板 2B (Controller B1): 2 routes (/phone/register-code + /phone/register-password)
//   - 5 拍板 3B (Username B1): 复用 vendor SignUpModal username field (vendor 已经
//     必填, 跟 v0.5.2 注册要求一致).
//   - 5 拍板 4B (Password B1): 密码模式注册时必填 password (minLength 8, 跟
//     vendor UserResource line 222 minLength 8 一致).
//   - 5 拍板 5B (自动登录 B1): 注册成功自动登录 (走 vendor SessionAuthenticator,
//     跟 v0.5.0/v0.5.1 + vendor RegisterController 一致).
//
// 跟 v0.5.0/0.5.1 PhoneLogin.js 关键差异:
//   - PhoneLogin 改 vendor LogInModal (登录), SignUp 改 vendor SignUpModal (注册)
//   - vendor SignUpModal fields 是 username (30) / email (20) / password (10) / submit (-10)
//   - phone mode 时 items.remove('email'/'password'/'submit') (SOP 254 修法, 跟 v0.5.1.a 一致)
//   - vendor SignUpModal 已有 username field, 我们直接复用 (不新建)
//   - vendor SignUpModal onsubmit 走 vendor /register (调用 vendor RegisterController),
//     我们 phone mode 拦截, 走 /api/ziven/core/phone/register-code 或 /register-password
//   - username 复用 vendor this.username Stream (vendor oninit 已经定义)
//   - 我们额外加 phoneMode/phoneSubMode/phoneNumber/phoneCode/phonePassword 等 Stream
//
// 8 Stream:
//   - phoneMode (false = 邮箱注册, true = 手机号注册)
//   - phoneSubMode (false = 验证码模式, true = 密码模式, 跟 v0.5.1 同款)
//   - phoneNumber / phoneCode / phoneSending / phoneCountdown (验证码模式用)
//   - phonePassword / phonePasswordSending / phonePasswordLockCountdown (密码模式用)
//
// 调用方: js/src/forum/index.js
// ====================================================================
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Stream from 'flarum/common/utils/Stream';
import Button from 'flarum/common/components/Button';
// v0.5.2: 复用 v0.5.0/0.5.1 公共 helpers (sendSmsCode / startCountdown / startPasswordLockCountdown / clearTimers)
import { sendSmsCode, startCountdown, startPasswordLockCountdown, clearTimers } from '../utils/phoneAuthHelpers';
export default function signUpExtension() {
  // SignUpModal 在 vendor 是 lazy chunk 加载, 用 onLoad 等 module 加载完再 extend
  // 跟 v0.5.0/v0.5.1 PhoneLogin.js 同款 pattern (SOP 250 沉淀)
  const flarumReg = typeof window !== 'undefined' && window.flarum && window.flarum.reg || typeof flarum !== 'undefined' && flarum.reg || null;
  if (!flarumReg) {
    console.warn('[ziven-core] signUpExtension: flarum.reg not available, skipped');
    return;
  }

  // 尝试立即拿 (可能已经同步注册)
  let SignUpModal = flarumReg.get('core', 'forum/components/SignUpModal');
  if (SignUpModal && SignUpModal.default) {
    SignUpModal = SignUpModal.default;
  }
  if (SignUpModal) {
    applyExtensions(SignUpModal);
  } else {
    // 模块未加载, 用 onLoad 等待
    flarumReg.onLoad('core', 'forum/components/SignUpModal', mod => {
      const cls = mod && mod.default ? mod.default : mod;
      if (cls) {
        applyExtensions(cls);
      } else {
        console.warn('[ziven-core] signUpExtension: SignUpModal module loaded but empty');
      }
    });
  }
}
function applyExtensions(SignUpModal) {
  if (!SignUpModal || !SignUpModal.prototype) {
    console.warn('[ziven-core] signUpExtension: SignUpModal has no prototype, skipped');
    return;
  }

  // ─────────────────────────────────────────────────────────────
  // oninit: 加 phone 模式状态 + phone 字段 Stream
  // ── v0.5.2 (Trello 卡 6a7fc343f990e73904af2c75, 辉哥 09:38 拍板) ──────────
  //   8 Stream (跟 v0.5.0/0.5.1 PhoneLogin 9 Stream 比少 1 个 v0.5.1 lockCountdown
  //   timer 名, 因为注册无失败场景 lock 几乎不动, 但保留兼容):
  //   - phoneMode: false = 邮箱注册, true = 手机号注册
  //   - phoneSubMode: false = 验证码模式, true = 密码模式
  //   - phoneNumber / phoneCode / phoneSending / phoneCountdown: 验证码模式
  //   - phonePassword / phonePasswordSending / phonePasswordLockCountdown: 密码模式
  //   复用 vendor username Stream (vendor oninit 已经定义 this.username, 5 拍板 3B)
  // ─────────────────────────────────────────────────────────────
  extend(SignUpModal.prototype, 'oninit', function () {
    this.phoneMode = Stream(false);
    this.phoneSubMode = Stream(false);
    this.phoneNumber = Stream('');
    this.phoneCode = Stream('');
    this.phoneSending = Stream(false);
    this.phoneCountdown = Stream(0);
    this.phonePassword = Stream('');
    this.phonePasswordSending = Stream(false);
    this.phonePasswordLockCountdown = Stream(0);
  });

  // ─────────────────────────────────────────────────────────────
  // fields: 加 phone tab 切换 + phone mode 字段
  // ── SOP 254 修法 (跟 v0.5.1.a 一致): phone mode 时 items.remove('email'/'password'/'submit')
  //   避免 vendor mithril vnode 引用缓存, wrap div hidden 实际从未渲染
  // ─────────────────────────────────────────────────────────────
  extend(SignUpModal.prototype, 'fields', function (items) {
    const phoneLoginEnabled = app.forum.attribute('zivenCorePhoneLoginEnabled');

    // 1. 顶部 tab 切换 UI (weight 100)
    if (phoneLoginEnabled) {
      items.add('phone-tab', m("div", {
        className: "Form-group ziven-core-signup-tabs"
      }, m("button", {
        type: "button",
        className: 'ziven-core-signup-tab ' + (!this.phoneMode() ? 'active' : ''),
        onclick: () => this.phoneMode(false)
      }, app.translator.trans('ziven-community-core.forum.signup_tab_email')), m("button", {
        type: "button",
        className: 'ziven-core-signup-tab ' + (this.phoneMode() ? 'active' : ''),
        onclick: () => this.phoneMode(true)
      }, app.translator.trans('ziven-community-core.forum.signup_tab_phone'))), 100);
    }

    // 2. phone mode 时, 隐藏 vendor email/password/submit (SOP 254 修法)
    if (phoneLoginEnabled && this.phoneMode()) {
      const hideKeys = ['email', 'password', 'submit'];
      hideKeys.forEach(k => {
        if (items.has(k)) {
          items.remove(k);
        }
      });
    }

    // 3. phone mode: 子 tab (验证码 / 密码) + phone input + (code 或 password) + submit
    if (phoneLoginEnabled && this.phoneMode()) {
      const phoneLabel = app.translator.trans('ziven-community-core.forum.login_phone_placeholder');
      const codeLabel = app.translator.trans('ziven-community-core.forum.login_code_placeholder');
      const passwordLabel = app.translator.trans('ziven-community-core.forum.login_password_placeholder');
      const usernameLabel = app.translator.trans('ziven-community-core.forum.signup_username_placeholder');

      // 3.1 子 tab 切换 (验证码 / 密码) — weight 95
      items.add('phone-sub-tab', m("div", {
        className: "Form-group ziven-core-sub-tabs"
      }, m("button", {
        type: "button",
        className: 'ziven-core-sub-tab ' + (!this.phoneSubMode() ? 'active' : ''),
        onclick: () => this.phoneSubMode(false)
      }, app.translator.trans('ziven-community-core.forum.login_sub_tab_code')), m("button", {
        type: "button",
        className: 'ziven-core-sub-tab ' + (this.phoneSubMode() ? 'active' : ''),
        onclick: () => this.phoneSubMode(true)
      }, app.translator.trans('ziven-community-core.forum.login_sub_tab_password'))), 95);

      // 3.2 username input (phone mode 时显示, 复用 vendor username Stream)
      //    vendor username weight 30, 我们 items.add 同 key 覆盖 (不重设 weight, vendor username 还在)
      //    实际: items.add('username', ...) 会覆盖 vendor items, 但 weight 跟 vendor 一致
      //    简化: 不重 add, vendor username 还显示, 我们 items.remove('email'/'password'/'submit') 后
      //    vendor username 保留. 5 拍板 3B: 复用 vendor username field.
      //    但我们想让 username 在子 tab 之后, weight 提到 35 (vendor 是 30)
      //    实际 items.add 同一 key 100, weight 跟新 add 走, 简化覆盖:
      items.add('username', m("div", {
        className: "Form-group"
      }, m("input", {
        className: "FormControl",
        name: "username",
        type: "text",
        placeholder: usernameLabel,
        "aria-label": usernameLabel,
        bidi: this.username,
        disabled: this.loading || this.phonePasswordLockCountdown() > 0
      })), 35);

      // 3.3 phone input (公共)
      items.add('phone-input', m("div", {
        className: "Form-group"
      }, m("input", {
        className: "FormControl",
        name: "phone",
        type: "tel",
        inputMode: "numeric",
        maxlength: "11",
        autocomplete: "tel",
        placeholder: phoneLabel,
        "aria-label": phoneLabel,
        bidi: this.phoneNumber,
        disabled: this.loading || this.phonePasswordLockCountdown() > 0
      })), 30);

      // 3.4 验证码模式: code input + 发送按钮
      if (!this.phoneSubMode()) {
        items.add('phone-code', m("div", {
          className: "Form-group ziven-core-phone-code-row"
        }, m("input", {
          className: "FormControl",
          name: "code",
          type: "text",
          inputMode: "numeric",
          maxlength: "6",
          autocomplete: "one-time-code",
          placeholder: codeLabel,
          "aria-label": codeLabel,
          bidi: this.phoneCode,
          disabled: this.loading
        }), m("button", {
          type: "button",
          className: "Button ziven-core-send-code-btn",
          disabled: this.loading || this.phoneSending() || this.phoneCountdown() > 0,
          onclick: this.sendSmsCode.bind(this)
        }, this.phoneCountdown() > 0 ? app.translator.trans('ziven-community-core.forum.login_resend_countdown', {
          seconds: this.phoneCountdown()
        }) : this.phoneSending() ? app.translator.trans('ziven-community-core.forum.login_sending') : app.translator.trans('ziven-community-core.forum.login_send_code'))), 15);
      }

      // 3.5 密码模式: password input (minLength 8, 跟 vendor UserResource 一致)
      if (this.phoneSubMode()) {
        const lockSeconds = this.phonePasswordLockCountdown();
        items.add('phone-password', m("div", {
          className: "Form-group"
        }, m("input", {
          className: "FormControl ziven-core-password-input",
          name: "phone-password",
          type: "password",
          autocomplete: "new-password",
          minlength: "8",
          maxlength: "32",
          placeholder: lockSeconds > 0 ? app.translator.trans('ziven-community-core.forum.login_password_locked', {
            minutes: Math.ceil(lockSeconds / 60)
          }) : passwordLabel,
          "aria-label": passwordLabel,
          bidi: this.phonePassword,
          disabled: this.loading || lockSeconds > 0
        })), 15);
      }

      // 3.6 submit button (走我们的 phoneRegisterCode / phoneRegisterPassword)
      items.add('phone-submit', m("div", {
        className: "Form-group"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        type: "submit",
        loading: this.loading || this.phonePasswordSending(),
        disabled: this.phoneSubMode() && this.phonePasswordLockCountdown() > 0,
        onclick: this.phoneSubMode() ? this.phoneRegisterPassword.bind(this) : this.phoneRegisterCode.bind(this)
      }, this.phoneSubMode() ? app.translator.trans('ziven-community-core.forum.signup_with_phone_password') : app.translator.trans('ziven-community-core.forum.signup_with_phone'))), -10);
    }
  });

  // ─────────────────────────────────────────────────────────────
  // onsubmit: phone mode 拦截, 走 phoneRegisterCode / phoneRegisterPassword
  // ── 跟 v0.5.0/v0.5.1 同款: override 而非 extend (SOP 253 签名错位)
  // ─────────────────────────────────────────────────────────────
  override(SignUpModal.prototype, 'onsubmit', function (original, e) {
    if (this.phoneMode && this.phoneMode()) {
      if (e && e.preventDefault) e.preventDefault();
      if (this.phoneSubMode && this.phoneSubMode()) {
        this.phoneRegisterPassword();
      } else {
        this.phoneRegisterCode();
      }
      return;
    }
    return original(e);
  });

  // ─────────────────────────────────────────────────────────────
  // onremove: 清掉倒计时 timer 避免内存泄漏 (跟 v0.5.0/0.5.1 同款)
  // ── v0.5.2: 抽 clearTimers helper 复用 (跟 PhoneLogin.js 同款)
  // ─────────────────────────────────────────────────────────────
  extend(SignUpModal.prototype, 'onremove', function () {
    clearTimers(this);
  });

  // ─────────────────────────────────────────────────────────────
  // 发送验证码 — POST /api/ziven/core/phone/send-code
  // ── v0.5.2: 抽 sendSmsCode helper 复用 (js/src/forum/utils/phoneAuthHelpers.js)
  //   v0.5.2 同时改了 SendSmsCodeController: 删 user_not_found 限制,
  //   未注册手机号也能发短信 (注册场景需要)
  // ─────────────────────────────────────────────────────────────
  SignUpModal.prototype.sendSmsCode = function () {
    sendSmsCode(this);
  };

  // ─────────────────────────────────────────────────────────────
  // 倒计时 (60s 防止连点) — v0.5.2 抽 startCountdown helper 复用
  // ─────────────────────────────────────────────────────────────
  SignUpModal.prototype.startCountdown = function () {
    startCountdown(this);
  };

  // ─────────────────────────────────────────────────────────────
  // 手机号 + 验证码注册 — POST /api/ziven/core/phone/register-code
  // ── v0.5.2 5 拍板 5B: 注册成功自动登录 (走 vendor SessionAuthenticator, reload 跳首页)
  // ─────────────────────────────────────────────────────────────
  SignUpModal.prototype.phoneRegisterCode = function () {
    const phone = (this.phoneNumber() || '').trim();
    const code = (this.phoneCode() || '').trim();
    const username = (this.username() || '').trim();

    // 前端基本校验
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.login_error_invalid_phone'));
      return;
    }
    if (!/^\d{6}$/.test(code)) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.login_error_invalid_code'));
      return;
    }
    if (!/^(?![0-9]*$)[a-z0-9_-]+$/i.test(username) || username.length < 3 || username.length > 30) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.signup_error_invalid_username'));
      return;
    }
    this.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ziven/core/phone/register-code',
      body: {
        phone,
        code,
        username
      },
      errorHandler: err => {
        this.loading = false;
        m.redraw();
        const code = err && err.status;
        if (code === 401) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_code_invalid'));
        } else if (code === 409) {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.signup_error_phone_or_username_taken');
          app.alerts.show({
            type: 'error'
          }, msg);
        } else if (code === 429) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_rate_limited'));
        } else if (code === 403) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_disabled'));
        } else {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.signup_error_failed');
          app.alerts.show({
            type: 'error'
          }, msg);
        }
      }
    }).then(response => {
      if (response && response.success && response.data) {
        // 服务端 session 已落, reload 走 Flarum session
        window.location.reload();
      }
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  };

  // ─────────────────────────────────────────────────────────────
  // 手机号 + 密码注册 — POST /api/ziven/core/phone/register-password
  // ── 跟 phonePasswordLogin (v0.5.1) 同款 pattern, 5 拍板 4B 必填 password
  // ── 注册无失败场景, 不调 PhonePasswordAttempt (5 拍板 4A 总开关已开)
  // ─────────────────────────────────────────────────────────────
  SignUpModal.prototype.phoneRegisterPassword = function () {
    const phone = (this.phoneNumber() || '').trim();
    const password = this.phonePassword() || '';
    const username = (this.username() || '').trim();

    // 前端基本校验
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.login_error_invalid_phone'));
      return;
    }
    if (password.length < 8 || password.length > 32) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.signup_error_invalid_password'));
      return;
    }
    if (!/^(?![0-9]*$)[a-z0-9_-]+$/i.test(username) || username.length < 3 || username.length > 30) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.signup_error_invalid_username'));
      return;
    }

    // 锁定检查 (前端防御性, 真锁定靠服务端)
    if (this.phonePasswordLockCountdown() > 0) {
      const minutes = Math.ceil(this.phonePasswordLockCountdown() / 60);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.login_error_password_locked', {
        minutes
      }));
      return;
    }
    this.phonePasswordSending(true);
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ziven/core/phone/register-password',
      body: {
        phone,
        password,
        username
      },
      errorHandler: err => {
        this.phonePasswordSending(false);
        m.redraw();
        const code = err && err.status;
        if (code === 409) {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.signup_error_phone_or_username_taken');
          app.alerts.show({
            type: 'error'
          }, msg);
        } else if (code === 423) {
          const lockRemaining = err && err.alert && err.alert.content && err.alert.content.lockRemaining || 600;
          this.startPasswordLockCountdown(lockRemaining);
          const minutes = Math.ceil(lockRemaining / 60);
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_password_locked', {
            minutes
          }));
        } else if (code === 429) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_rate_limited'));
        } else if (code === 403) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_disabled'));
        } else {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.signup_error_failed');
          app.alerts.show({
            type: 'error'
          }, msg);
        }
      }
    }).then(response => {
      this.phonePasswordSending(false);
      if (response && response.success && response.data) {
        // 服务端 session 已落, reload 走 Flarum session
        window.location.reload();
      }
    }).catch(() => {
      this.phonePasswordSending(false);
      m.redraw();
    });
  };

  // ─────────────────────────────────────────────────────────────
  // v0.5.2 锁定倒计时 — 抽 startPasswordLockCountdown helper 复用
  // ─────────────────────────────────────────────────────────────
  SignUpModal.prototype.startPasswordLockCountdown = function (seconds) {
    startPasswordLockCountdown(this, seconds);
  };
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/SignUp', signUpExtension);